import React from 'react';
import { BALANCE_LEAVE_LABELS, BalanceLeaveType, EmployeeLeave } from '../../../config';
import { formatLeaveDays, formatLeaveHours } from './leaveFormat';

interface LeaveBalanceStatsProps {
  leave: EmployeeLeave;
}

const TYPES: BalanceLeaveType[] = ['personal', 'sick_leave'];

/** What is available now, for both leave types, whichever one is being inspected. */
const LeaveBalanceStats: React.FC<LeaveBalanceStatsProps> = ({ leave }) => (
  <div className="stat-grid leave-tab__stats">
    {TYPES.map((type) => {
      const totals = leave.totals[type];
      const balance = Number(totals.balance);
      return (
        <div key={type} className={`stat ${balance < 0 ? 'is-negative' : ''}`.trim()}>
          <span className="stat__value">{formatLeaveHours(balance)}</span>
          <span className="stat__label">
            {BALANCE_LEAVE_LABELS[type]} available · {formatLeaveDays(balance, leave.standard_hours_per_day)}
          </span>
          <span className="leave-tab__stat-basis">
            {type === 'sick_leave'
              ? `Earned in ${leave.current_year}. Resets on 1 January ${leave.current_year + 1}.`
              : 'Carries over from year to year.'}
          </span>
          {Number(totals.pending) > 0 && (
            <span className="leave-tab__stat-note">
              {formatLeaveHours(Number(totals.pending))} more in a week not yet submitted
            </span>
          )}
        </div>
      );
    })}
  </div>
);

export default LeaveBalanceStats;
